module.exports = __webpack_public_path__ + "static/media/Docs.9ad975b7.png";